const { signal } = require("@preact/signals");

export const productSignal = signal(null);